import { Component, OnInit, Inject } from '@angular/core';
import * as moment from 'moment';
import { MatDialogRef, MAT_DIALOG_DATA } from '../../../../node_modules/@angular/material';
import { InvoiceResponse } from '../../models/invoice.model';
import { HelperService } from '../../services/helper.service';

@Component({
  selector: 'app-car-invoice-print',
  templateUrl: './car-invoice-print.component.html',
  styleUrls: ['./car-invoice-print.component.scss']
})
export class CarInvoicePrintComponent implements OnInit
{
  mymoment = moment;

  imgFile;
  imgLoaded = false;

  constructor(
    public dialogRef: MatDialogRef<CarInvoicePrintComponent>,
    @Inject(MAT_DIALOG_DATA) public data: InvoiceResponse,
    private helper: HelperService
  )
  {
    this.mymoment().locale('de');
  }

  ngOnInit()
  {
    console.log('Data', this.data);

    if (this.data.qr_image)
    {
      this.imgFile = 'data:image/png;base64,' + this.data.qr_image;
    }
    else if (this.data.qr_url)
    {
      this.helper.getBase64ImageFromUrl(this.data.qr_url)
        .then(result =>
        {
          this.imgFile = result;
        })
        .catch(err => console.error(err));
    }
    else
    {
      this.imgFile = null;
      this.imgLoaded = true;
      setTimeout(() => {
        this.printInvoice();
      }, 100);
    }
  }

  printInvoice()
  {
    try
    {
      this.imgLoaded = true;
      const div = document.getElementById('print-content');

      const mywindow = window.open('', '_blank');
      mywindow.document.write('<html><head><title>' + document.title + '</title><style>*{font-size:10px}body{width: 1.8in; font-family:Arial} table{width:100%}</style>');
      mywindow.document.write('</head><body>');
      mywindow.document.write(div.innerHTML);
      mywindow.document.write('</body></html>');

      mywindow.document.close(); // necessary for IE >= 10
      mywindow.focus(); // necessary for IE >= 10*/

      mywindow.print();
      mywindow.close();

      // this.dialogRef.close();
    }
    catch (error)
    {
      console.log('Error has occured when trying to open a new tab: \n\n', error);
    }
  }
}
